module.exports = __webpack_public_path__ + "img/alur-ppdb.594f1295.png";